import { cn } from "cn";
import type { HTMLAttributes } from "react";

type TextElement = "h1" | "h2" | "h3" | "h4" | "p" | ("span" & {});

type TextProps<T extends TextElement> = {
  as?: T;
  children: React.ReactNode;
} & HTMLAttributes<HTMLElementTagNameMap[T]>;

const styles: Record<TextElement, string> = {
  h1: "text-2xl font-serif pb-4",
  h2: "text-lg font-serif pb-1",
  h3: "",
  h4: "",
  p: "text-base pb-2",
  span: "text-base pb-2",
} as const;

export function MarketingText<T extends TextElement = "p">({
  as,
  children,
  className,
  ...props
}: TextProps<T>) {
  const Component = as || "p";
  const baseStyles = styles[Component];

  return (
    <Component className={cn(baseStyles, className, "text-pretty")} {...props}>
      {children}
    </Component>
  );
}
